<div class="pulse-container">
    <h2>Loading...</h2>
    <img id="logo" src="assets/app-hub-logo.png" alt="app-hub-logo" />
</div>